/**
 * Badge — inline skill or tag pill.
 * Props: children, variant ('default' | 'accent')
 */
export function Badge({ children, variant = 'default', className = '' }) {
  const base = 'inline-block px-2.5 py-0.5 rounded-full text-xs font-medium tracking-wide';
  const variants = {
    default: 'bg-white/[0.06] text-[var(--color-muted)] border border-white/[0.08]',
    accent:  'bg-[var(--color-accent)]/10 text-[var(--color-accent)] border border-[var(--color-accent)]/20',
  };
  return (
    <span className={`${base} ${variants[variant] ?? variants.default} ${className}`}>
      {children}
    </span>
  );
}
